import React from 'react'
import { HaircutSign } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { getEnumValues, HaircutSignTypeHelper } from 'model'

export interface HaircutSignSelectboxProps extends Omit<SelectboxProps<HaircutSign, HaircutSign>, 'optionKeys'> {
  isSellSideTrader: boolean
}

export const HaircutSignSelectbox = React.forwardRef((props: HaircutSignSelectboxProps, ref: React.Ref<Selectbox>) => {
  const optionKeys = getEnumValues(HaircutSign).filter(
    haircutSign => !props.isSellSideTrader || (haircutSign !== HaircutSign.DIRECTIONAL && haircutSign !== HaircutSign.NEGATIVE_REV_REPO)
  )

  return <Selectbox ref={ref} optionKeys={optionKeys} getOptionText={HaircutSignTypeHelper.getName} {...props} />
})

export const HaircutSignSelectboxField = Field(HaircutSignSelectbox)
